import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MustMatch } from '../../../../helper/must-match.validator';
import { LoginService } from '../../services/login.service';
import { PasswordEmailModel } from '../../models/EmailPasswordChangeModel';
import { GetUserResult, UserResetmail } from '../../models/UserModel';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-first-login',
  templateUrl: './first-login.component.html',
  styleUrls: ['./first-login.component.css']
})
export class FirstLoginComponent implements OnInit, OnDestroy {
  @Input() clients;
  @Input() defaultLanguage;
  @Input() federaleURL;
  @Output() displayLogin: EventEmitter<any> = new EventEmitter();
  @Output() displayReset: EventEmitter<any> = new EventEmitter();
  @Output() onHeaderDisplay: EventEmitter<any> = new EventEmitter();
  
  selectLanguage: boolean;
  selectedLanguage;
  welcome: string;
  FormEmailPwdChange: FormGroup;
  fetchedUserName: string;
  fetchedPwd: string;
  emailMustMatch: boolean = false;
  pwdMustMatch: boolean = false;
  error: boolean = false;
  public pwdEmailModel: PasswordEmailModel;
   userMail : UserResetmail;
   ResetLink :string;
   ResetUri : string=  environment.sofiaMailURL;
   sofiaPreferencesURL :string="%=%SOFIAURL%=%";
   navigationLink : string ="%=%LINK%=%";
   idUser : string;
   flChgPsw : boolean;
   getUserResult :  GetUserResult;
   mailSentFlg : boolean =false;
   userName : string;

  updatedEmail: any;
  updatedPassword: any;
  fetchedUserId: string;
  msgErrorPwd: boolean = false;
  msgErrorEmail: boolean = false;
  fetchedEmail: string;
  isEmailIdPresent: boolean = false;
  Confirmemail: any;
  mail: any;
  isEmailMadetory: boolean = false;
  isConfirmEmailMadetory : boolean = false;
  confPwd: any;
  pwd: any;
  pwdRequired: boolean = false;
  isEmailRequired: boolean;
  isCallSetEmail: boolean = false;
  display: boolean;
  checkClientSelectionPage: boolean = true;
  IsEmailPatternUnmatched: boolean;
  IsPwdLenghtIncorrect: boolean;
  email: any;
  userRole :string;
  status : string;
  role_CO_x : boolean;
  role_AF_x :boolean;
  role_SS_x : boolean;

  role_CO_y : boolean;
  role_AF_y : boolean;
  role_SS_y : boolean;
  showResetPassScreen : boolean;



  constructor(private formBuilder: FormBuilder,
    private translate: TranslateService,
    private _router: Router,
    private loginService: LoginService) {
    this.pwdEmailModel = new PasswordEmailModel();
    this.getUserResult = new GetUserResult();
    this.userMail = new UserResetmail();
  }

  ngOnInit(): void {

    this.FormEmailPwdChange = this.formBuilder.group({

      emailAddress: ['', [Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$")]],
      emailAddressConfirmed: ['', [Validators.email,Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$")]],

      password: ['', [Validators.minLength(8), Validators.maxLength(100)]],
      passwordConfirmed: ['', [Validators.minLength(8)]]
    });
      

    var currentlang = sessionStorage.getItem("currentlang")
    this.switchLang(currentlang);
    // this.userRole = sessionStorage.getItem('ROLE');
    this.fetchedUserName = sessionStorage.getItem('UN');
    this.fetchedPwd = sessionStorage.getItem('PWD');
    this.fetchedUserId = sessionStorage.getItem('IdUsr');
    this.fetchedEmail = sessionStorage.getItem('MAIL');
    if (this.fetchedEmail == 'null' || this.fetchedEmail == undefined || this.fetchedEmail == "") {
      this.fetchedEmail = " ";
      this.isEmailIdPresent = false;
      this.isEmailRequired = true;
    }
    else {
      this.isEmailIdPresent = true;
      this.isEmailRequired = false;
    }

    this.loginService.GetUser(this.fetchedUserName).subscribe(
      (data)=>{

                        if(data!="Failed")
                        {
                            this.userRole = data.NmCteUsrMap.slice(data.NmCteUsrMap.length -2);
                            this.status = data.LbSta;
                            this.idUser = data.IdUsr;
                            this.flChgPsw = data.FlChgPsw;
                            this.userName = this.fetchedUserName;
                            sessionStorage.setItem("token", data.Token);
                            
                            if(this.status=='FINAL' && this.flChgPsw)
                            {
                                this.showResetPassScreen= true;

                                
                            }
                            
                            if(this.userRole=="CO")
                            {
                               this.role_CO_x =true;
                               this.role_CO_y = true;
                            }
                            else
                            if(this.userRole=="SS")
                            {
                              this.role_SS_x =true;
                              this.role_SS_y =true;
                            }
                            else
                            {
                              this.role_AF_x =true;
                             this.role_AF_y =true; 
                            }
                            

                        }
      },
      (err) => {
          //error
        }
      );
  }

  ngOnDestroy() {
    sessionStorage.removeItem('UN');
    sessionStorage.removeItem('PWD');
    sessionStorage.removeItem('IdUsr');
    sessionStorage.removeItem('MAIL');
    

  }

  changeLanguage() {

    if (this.translate.currentLang == 'FR') {
      this.defaultLanguage = "NL";
      sessionStorage.setItem("currentlang", "NL")
      sessionStorage.setItem("presentLang", "Even geduld, we zijn uw gegevens aan het laden");
      document.getElementById('languageDropdown').innerHTML = 'FR';
      (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-NL.svg';
    } else {
      this.defaultLanguage = "FR";
      sessionStorage.setItem("currentlang", "FR")
      sessionStorage.setItem("presentLang", "Veuillez patienter svp, nous chargeons vos données");
      document.getElementById('languageDropdown').innerHTML = 'NL';
      (<HTMLImageElement>document.getElementById("langlogo")).src = 'assets/Logos/logo-FR.svg';
    }
    this.switchLang(this.defaultLanguage);

  }

  switchLang(lang: string) {
    this.defaultLanguage = lang;
    this.translate.use(lang);

  }

  // Validate & Call Service to SAVE THE DETAILS -
  ValidateAndSave() {
    this.IsEmailPatternUnmatched = false;
    
    if (this.FormEmailPwdChange.get('emailAddress').status == 'INVALID') {
      this.IsEmailPatternUnmatched = true;
      this.isEmailMadetory = false;
      return;
    }
    
    this.email = this.FormEmailPwdChange.get('emailAddress').value;
    this.Confirmemail = this.FormEmailPwdChange.get('emailAddressConfirmed').value;
    this.mail = this.FormEmailPwdChange.get('emailAddress').value;

    if((this.email != (null || undefined || "") )&& this.Confirmemail!=(null || undefined || ""))
    this.emailMatchValidation();
    
    

    // if (this.isEmailRequired) {
      if (this.email == (null || undefined || "") || this.mail == (null || undefined || "")) {
        this.isEmailMadetory = true;
        this.emailMustMatch = false;
        this.isConfirmEmailMadetory = false;
        return false;
      }
      else {
        this.isEmailMadetory = false;
      }
    // }

    if (this.Confirmemail == (null || undefined || "") ) {
      this.isConfirmEmailMadetory = true;
      this.isEmailMadetory = false;
      this.emailMustMatch = false;
      return false;
    }
    else {
      this.isConfirmEmailMadetory = false;
    }

    if (this.Confirmemail !== (null || undefined || "") || this.mail !== (null || undefined || "")) {
      this.isCallSetEmail = true;
    }

    
    if (this.FormEmailPwdChange.invalid) {
      return false;
    }
    if (this.emailMustMatch) {
      return false;
    }
    

    else {
      //Filling the model data -
      this.pwdEmailModel.UserName = this.fetchedUserName;
      
      this.pwdEmailModel.Email = this.FormEmailPwdChange.get('emailAddress').value;
      this.pwdEmailModel.UID = this.fetchedUserId;
      // this.pwdEmailModel.IsEmailIdPresent = this.isCallSetEmail;
       this. mailSentFlg = true;
      
       
         if(this.status=="EMAIL VALIDATION PENDING" && this.pwdEmailModel.Email !='')
         {
          
           this.getUserResult.IdUsr = this.idUser;
           this.getUserResult.FlChgPsw = this.flChgPsw;
           this.getUserResult.TlAdrEmlUsr = this.FormEmailPwdChange.get('emailAddress').value;
            this.getUserResult.NmCteUsr = this.userName;         
            this.getUserResult.Languagecode = this.defaultLanguage; 
          this.loginService.EncryptUserDetails(this.getUserResult).subscribe(
                    (data) => {
        
                                      this.userMail.Subject=this.translate.instant('FirstLogin_mailSubject_001');
                                      this.userMail.To=  this.FormEmailPwdChange.get('emailAddress').value;
                                      this.userMail.Body = this.translate.instant('FirstLogin_mail_001');
                                      this.userMail.Language=  sessionStorage.getItem("currentlang");
                                      this.userMail.ContentType="text/html";
                                  this.ResetLink= `${this.ResetUri}/app-first-login-passwordreset?userName=${data.NmCteUsr}&flChgPsw=${data.flChgPsw}&Timestamp=${data.timestamp}&email=${data.TlAdrEmlUsr}&Languagecode=${data.Languagecode}`;
                                     
                                  this.userMail.Body= this.userMail.Body.replace(this.sofiaPreferencesURL,this.ResetLink);
                                  this.userMail.Body= this.userMail.Body.replace(this.navigationLink,this.ResetLink);
        
                            this.loginService.SendEmail(this.userMail).subscribe(
                              (data)=>{
        
                                this. mailSentFlg = true;
        
                              }
                            )
                     },
                     (err) => {
                      
                     }
                   );
               

          
      }
    }
  }

  //Check Both Fields are Same - EMAIL
  emailMatchValidation() {
    if (this.FormEmailPwdChange.get('emailAddress').value !== this.FormEmailPwdChange.get('emailAddressConfirmed').value) {
      this.emailMustMatch = true;
      this.isEmailMadetory = false;
      this.isConfirmEmailMadetory = false;
      return;
    }
    else {
      this.updatedEmail = this.FormEmailPwdChange.get('emailAddress').value;
      this.emailMustMatch = false;
      return;
    }
  }


  //Check Both Fields are Same - Password
  passwordMatchValidation() {
    if (this.FormEmailPwdChange.get('password').value !== this.FormEmailPwdChange.get('passwordConfirmed').value) {
      this.pwdMustMatch = true;
      return;
    }
    else {
      this.updatedPassword = this.FormEmailPwdChange.get('password').value;
      this.pwdMustMatch = false;
      return;
    }
  }

  gotoClientSelection() {
    this.clients = JSON.parse(sessionStorage.getItem("ClientsData"));
    this._router.navigate(['/client-selection']);
  }

  gotoLogin() {
    this._router.navigate(['']);
  }

}
